import { Base } from "../core/base.model";
import { SafeUrl } from "@angular/platform-browser";

export class PublicidadDashboard extends Base {

    id: number;
    titulo: String;
    descripcion: String;
    url: String;
    imagen: String;

    //para mostrar la imagen
    imagenConvert: SafeUrl;

    //para guardar la imagen 
    saveImagen:  FormData;

    



}